/* eslint-disable no-console */
import Store from 'lightningjs-redux';
import jwtDecode from 'jwt-decode';
import { completeAccount } from '../user/user.actions';

export const patchOIDC = base => {
  base.setTokens = function setTokens({ accessToken, refreshToken, idToken }) {
    this.tokenManager.setAccessToken(accessToken);
    this.tokenManager.setRefreshToken(refreshToken);
    this.tokenManager.setIdToken(idToken);

    // This logic is specific to Magenta SSO
    if (accessToken && this.isTokenValid(accessToken)) {
      try {
        const decodedToken = jwtDecode(accessToken);
        if (decodedToken.birthdate) {
          Store.dispatch(completeAccount());
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[OIDC] Can not fetch birthdate from JWT${error ? `: ${error.message}` : ''}`);
      }
    }
  };
};
